import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { QueryParams } from "@app/shared/models";
import { ProfessionalSport } from "@app/shared/models/dict/professional-sport.model";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

export interface ProfessionalSportResponse {
  data: ProfessionalSport[];
  message: string;
}

@Injectable({
  providedIn: "root",
})
export class DirectoryService {
  constructor(private http: HttpClient) {}

  loadDietRestrictions(): Observable<any[]> {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/diet_restriction`,
    );
  }
  // todo хер пойми как оно работает, необходимо разобраться
  loadMedicaments(parameters?: QueryParams): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/medicaments`, {
      params: { ...parameters },
    });
  }
  // todo хер пойми как оно работает, необходимо разобраться
  loadDiseases(parameters?: QueryParams): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/diseases`, {
      params: { ...parameters },
    });
  }
  // todo хер пойми как оно работает, необходимо разобраться
  loadProducts(queryParams: QueryParams): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/products`, {
      params: { ...queryParams },
    });
  }

  // todo хер пойми как оно работает, необходимо разобраться
  loadFoodList(parameters?: QueryParams): Observable<any> {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/products_recipes`,
      {
        params: { ...parameters },
      },
    );
  }

  // todo хер пойми как оно работает, необходимо разобраться
  loadDrinks(parameters?: QueryParams): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/products`, {
      params: { ...parameters, only_drinks: "true" },
    });
  }

  loadDietTypes(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/diet_type`);
  }

  loadCategories(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/category`);
  }

  loadWorkingGroups(token: string | null): Observable<any> {
    if (token) {
      return this.http.get<any>(
        `${environment.primaryApiUrl}/dict/working_groups`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
    }

    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/working_groups`,
    );
  }

  loadGenderTypes(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/gender`);
  }

  loadCookingTypes(params: QueryParams = {}): Observable<any> {
    const { limit, search } = params;

    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/cooking_type?limit=${
        limit ? limit : 11
      }` + (search ? `&search=${search}` : ""),
    );
  }

  loadSportLevelList(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/sports`);
  }

  loadProfessionalSportList(): Observable<ProfessionalSportResponse> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/prof-sport`);
  }

  loadDrinkGroupList(): Observable<any> {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/tags/group/drink`,
    );
  }

  loadProductGroupList(): Observable<any> {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/tags/group/product`,
    );
  }

  loadRecipeGroupList(): Observable<any> {
    return this.http.get<any>(
      `${environment.primaryApiUrl}/dict/tags/group/recipe`,
    );
  }

  loadDishes(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/dish`);
  }

  loadUnits(): Observable<any> {
    return this.http.get<any>(`${environment.primaryApiUrl}/dict/units`);
  }
}
